<div class="col-12 text-center covered-parts-button">
  <div class="disclaimer">{{ 'RATES_PAGE.COVERAGE_EXCLUSIONS' | translate }}</div>
  <div>
    @if ((prismicPDF$ | async); as prismicPDF) {
      <span id="coveredComponentsSampleContractLink" class="click-text" (click)="showPDF(prismicPDF.pdf)">{{ 'CART_CHECKOUT.VIEW_AGREEMENT_EXCLUSIONS' | translate }}</span>
    }
  </div>
</div>
